import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import LoadField from '../components/LoadField';
import MoneyField from '../components/MoneyField';
import { WAButton, PhoneButton } from '../components/Button.js';
require(`../assets/${process.env.PAGE}/css/components/Summary.css`);
import axios from 'axios';

class Summary extends Component {

    constructor(props) {
        super(props);
        this.state = {

            requested_amount: null,
            requested_quotas: null,
            total_amount: null,
            quota_amount: null,
            interest: null,
            interest_tax: null,
            first_payment_date: null,
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                let total_amount = data.requested_quotas * data.quota_amount;
                let interest_tax = ((total_amount - data.requested_amount) * 0.21) / 1.21
                let interest = (total_amount - data.requested_amount) - interest_tax;
                this.setState({ 'requested_amount': data.requested_amount });
                this.setState({ 'requested_quotas': data.requested_quotas });
                this.setState({ 'quota_amount': data.quota_amount });
                this.setState({ 'total_amount': total_amount });
                this.setState({ 'interest': interest });
                this.setState({ 'interest_tax': interest_tax });
                this.setState({ 'first_payment_date': data.first_payment_date });
            }
        );
    }

    render() {
        return (
            <div className="summary text-center">
                <div className="summary_details">
                    <h4> Resumen de tu solicitud </h4>
                    <h4> Préstamo Personal </h4>
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                    <moneyField/>
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Monto del Préstamo: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.requested_amount && (<MoneyField decimals={0} >{ this.state.requested_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <div className="summary_line"></div>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Valor de la cuota: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.quota_amount && (<MoneyField>{ this.state.quota_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Cuotas: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                {this.state.requested_quotas}
                            </LoadField>
                        </Col>
                    </Row>
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Costos Administrativos: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>$ 0</Col>
                    </Row>
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Pago de la cuota: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                             Del 1 al 10 de cada mes.
                        </Col>
                    </Row>
                    <div className="summary_line"></div>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={12} md={12} lg={12}><FormattedHTMLMessage id="app.step_checkout_info" description="Checkout advice"/></Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Summary;



/** WEBPACK FOOTER **
 ** ./src/components/Summary.js
 **/